import { faBookmark, faDownload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CancelModalButton from 'components/Custom/CancelModalButton'
import CustomModalFooter from 'components/Custom/CustomModalFooter'
import CustomModalHeader from 'components/Custom/CustomModalHeader'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { FormGroup, Input, Label, Modal, ModalBody } from 'reactstrap'
import { extractReport } from 'store/CustomReports/actions'

function SaveDownloadModal({
  showSaveDownloadModal,
  setShowSaveDownloadModal,
}) {
  const { downloading, savingAndDownloading, report, editingReport } =
    useSelector((store) => store.customReports)
  const dispatch = useDispatch()
  const [reportName, setReportName] = useState(report?.name || '')
  const [reportDescription, setReportDescription] = useState(
    report?.description || ''
  )

  return (
    <Modal
      toggle={() => {
        setShowSaveDownloadModal(false)
      }}
      isOpen={showSaveDownloadModal}
      centered
      size='lg'
      className='scrollbar'
    >
      <CustomModalHeader
        title={'Save & Download Report'}
        toggle={() => {
          setShowSaveDownloadModal(false)
        }}
      />
      <ModalBody style={{ padding: '20px' }}>
        <p className='text-center'>
          Would you like to save this report configuration for future use, or
          just download it now?
        </p>
        <FormGroup className='ml-0 w-75 mx-auto my-4'>
          <Label htmlFor='reportName'>
            Report Name <span className='text-danger'>*</span>
          </Label>
          <Input
            id='reportName'
            name='reportName'
            type='text'
            style={{ height: '38px' }}
            value={reportName}
            onChange={(e) => setReportName(e.target.value)}
          />
        </FormGroup>
        <FormGroup className='ml-0 w-75 mx-auto my-4'>
          <Label htmlFor='reportDescription'>Report Description</Label>
          <Input
            id='reportDescription'
            name='reportDescription'
            type='textarea'
            rows={4}
            value={reportDescription}
            onChange={(e) => setReportDescription(e.target.value)}
          />
        </FormGroup>
        <CustomModalFooter>
          {editingReport && (
            <SubmitModalButton
              customFn={() =>
                dispatch(
                  extractReport(reportName, reportDescription, true, false)
                )
              }
              icon={<FontAwesomeIcon icon={faBookmark} className='mr-2' />}
              text={'Save'}
            />
          )}
          <SubmitModalButton
            customFn={() =>
              dispatch(extractReport(reportName, reportDescription, true))
            }
            icon={<FontAwesomeIcon icon={faBookmark} className='mr-2' />}
            text={
              !savingAndDownloading
                ? 'Save & Download'
                : 'This may take a while...'
            }
            disabled={!reportName}
          />
          <SubmitModalButton
            customFn={() => dispatch(extractReport(reportName))}
            icon={<FontAwesomeIcon icon={faDownload} className='mr-2' />}
            text={!downloading ? 'Download' : 'This may take a while...'}
          />

          <CancelModalButton
            customFn={() => setShowSaveDownloadModal(false)}
            text='Cancel'
          />
        </CustomModalFooter>
      </ModalBody>
    </Modal>
  )
}

export default SaveDownloadModal
